<template>
  <div class="absolute bottom-0 left-0 w-full flex items-center h-[40px] gap-3 bg-black/40 px-2 menu">
    <button
      v-if="!adapter.play"
      class="p-0"
      @click="play"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        stroke-width="1.5"
        stroke="currentColor"
        class="w-6 text-white"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          d="M5.25 5.653c0-.856.917-1.398 1.667-.986l11.54 6.347a1.125 1.125 0 0 1 0 1.972l-11.54 6.347a1.125 1.125 0 0 1-1.667-.986V5.653Z"
        />
      </svg>
    </button>
    <button
      v-else
      class="p-0"
      @click="pause"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        fill="currentColor"
        class="w-6 text-white"
      >
        <path
          fill-rule="evenodd"
          d="M6.75 5.25a.75.75 0 0 1 .75-.75H9a.75.75 0 0 1 .75.75v13.5a.75.75 0 0 1-.75.75H7.5a.75.75 0 0 1-.75-.75V5.25Zm7.5 0A.75.75 0 0 1 15 4.5h1.5a.75.75 0 0 1 .75.75v13.5a.75.75 0 0 1-.75.75H15a.75.75 0 0 1-.75-.75V5.25Z"
          clip-rule="evenodd"
        />
      </svg>
    </button>

    <div
      class="text-white relative flex gap-2 items-center"
      @mouseenter="volumePanel = true"
      @mouseleave="volumePanel = false"
    >
      <span
        v-if="adapter.mute"
        class="cursor-pointer"
        @click="muteUnmute"
      >Muted!</span>
      <button
        class="text-white flex items-center gap-2 font-semibold p-0"
        @click="muteUnmute"
      >
        <svg
          v-if="adapter.mute"
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          stroke-width="1.5"
          stroke="currentColor"
          class="max-sm:w-5 max-sm:h-5 w-6 h-6"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M17.25 9.75 19.5 12m0 0 2.25 2.25M19.5 12l2.25-2.25M19.5 12l-2.25 2.25m-10.5-6 4.72-4.72a.75.75 0 0 1 1.28.53v15.88a.75.75 0 0 1-1.28.53l-4.72-4.72H4.51c-.88 0-1.704-.507-1.938-1.354A9.009 9.009 0 0 1 2.25 12c0-.83.112-1.633.322-2.396C2.806 8.756 3.63 8.25 4.51 8.25H6.75Z"
          />
        </svg>
        <svg
          v-else
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          stroke-width="1.5"
          stroke="currentColor"
          class="max-sm:w-5 max-sm:h-5 w-6 h-6"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M19.114 5.636a9 9 0 0 1 0 12.728M16.463 8.288a5.25 5.25 0 0 1 0 7.424M6.75 8.25l4.72-4.72a.75.75 0 0 1 1.28.53v15.88a.75.75 0 0 1-1.28.53l-4.72-4.72H4.51c-.88 0-1.704-.507-1.938-1.354A9.009 9.009 0 0 1 2.25 12c0-.83.112-1.633.322-2.396C2.806 8.756 3.63 8.25 4.51 8.25H6.75Z"
          />
        </svg>
      </button>

      <div
        class="transition-[.8s] overflow-hidden"
        :class="volumePanel ? 'w-[70px]' : 'w-[0px]'"
      >
        <div class="flex items-center justify-center rounded">
          <input
            v-model="volume"
            type="range"
            min="0"
            max="1"
            step="0.01"
            class="!w-[70px] h-[6px] range-slider"
            @input="updateVolume"
          >
        </div>
      </div>
    </div>

    <button
      class="mr-auto flex items-center gap-2 text-white text-[14px] p-0"
      @click="seek"
    >
      <div
        class="rounded-full w-3 h-3 animate-pulse"
        :class="adapter.latency > 5 ? 'bg-gray-500' : 'bg-red-500'"
      />
      Live
    </button>

    <svg
      width="69"
      height="10"
      viewBox="0 0 69 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      class="ml-auto"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M24.6216 0.768616V1.31544V2.28583H27.9897V9.47687H29.4618V2.28583H32.8176V1.31544V0.768616H24.6216Z"
        fill="white"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M20.5649 4.81948C20.0164 4.33989 19.3309 4.10009 18.5079 4.10009H14.6904C14.4079 4.10009 14.167 4.02437 13.9674 3.87303C13.768 3.72151 13.6684 3.50692 13.6684 3.22935C13.6684 2.95995 13.768 2.74545 13.9674 2.58558C14.167 2.42581 14.4079 2.34579 14.6904 2.34579H20.9139V1.37468V0.843933H14.6904C13.9506 0.843933 13.3318 1.05027 12.8332 1.46231C12.301 1.90845 12.0352 2.49309 12.0352 3.2167C12.0352 3.94875 12.301 4.5377 12.8332 4.98356C13.3318 5.39597 13.9506 5.60213 14.6904 5.60213H18.5079C18.9151 5.60213 19.264 5.69031 19.5551 5.86713C19.9041 6.0775 20.0786 6.37624 20.0786 6.76307C20.0786 7.15018 19.9083 7.45744 19.5676 7.68441C19.2684 7.86957 18.9151 7.96225 18.5079 7.96225H12.2098V8.93134V9.46401H18.5079C19.3309 9.46401 20.0164 9.23264 20.5649 8.76991C21.1382 8.27345 21.4249 7.6174 21.4249 6.80112C21.4249 5.98492 21.1382 5.32429 20.5649 4.81948Z"
        fill="white"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M0.0327148 9.46403H8.17332V8.92806V7.96199H1.51619V5.84185H8.17332V5.30597V4.3399H0.0327148V9.46403Z"
        fill="white"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M0.0327148 2.34704H8.17332V1.81116V0.845093H0.0327148V2.34704Z"
        fill="white"
      />
      <mask
        id="mask0_3517_8466"
        style="mask-type:luminance"
        maskUnits="userSpaceOnUse"
        x="60"
        y="4"
        width="9"
        height="6"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M60.5659 4.34033H68.7065V9.46454H60.5659V4.34033Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask0_3517_8466)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M60.5659 5.84237V7.96251V9.46454H68.7065V8.92857V7.96251H62.0494V5.84237H68.7065V5.3064V4.34033H60.5659V5.84237Z"
          fill="white"
        />
      </g>
      <mask
        id="mask1_3517_8466"
        style="mask-type:luminance"
        maskUnits="userSpaceOnUse"
        x="60"
        y="0"
        width="9"
        height="3"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M60.5659 0.844421H68.7065V2.34637H60.5659V0.844421Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask1_3517_8466)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M60.5659 0.844421V2.34637H68.7065V1.81049V0.844421H60.5659Z"
          fill="white"
        />
      </g>
      <mask
        id="mask2_3517_8466"
        style="mask-type:luminance"
        maskUnits="userSpaceOnUse"
        x="33"
        y="0"
        width="13"
        height="10"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M33.5513 0.830994H45.0074V9.47635H33.5513V0.830994Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask2_3517_8466)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M40.0087 1.10856C39.7759 0.923576 39.5514 0.830994 39.3353 0.830994C39.1361 0.830994 38.9116 0.927701 38.6624 1.1213C38.4546 1.28969 38.2923 1.47467 38.1762 1.6767L33.5513 9.46381H35.4586L39.298 3.07745L40.7814 5.56398H39.311L38.4134 7.05318H41.6666L43.1002 9.46381L45.0074 9.47637L40.4947 1.6767C40.3702 1.4578 40.2079 1.26851 40.0087 1.10856Z"
          fill="white"
        />
      </g>
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M48.4285 2.00497C47.6265 2.77937 47.2256 3.79722 47.2256 5.05928C47.2256 6.32977 47.6307 7.38163 48.4411 8.2146C49.2511 9.04757 50.2754 9.4641 51.5138 9.4641H56.7274V6.20675V4.70591V4.70499H53.7423V6.20675H55.2441V7.96225H51.5138C50.6992 7.96225 50.0282 7.70558 49.5006 7.19234C48.9727 6.67911 48.709 6.01022 48.709 5.1855C48.709 4.35263 48.9727 3.671 49.5006 3.1409C50.0282 2.61079 50.6992 2.34579 51.5138 2.34579H56.7274V1.38522V0.843933H51.5138C50.2588 0.843933 49.2304 1.23095 48.4285 2.00497Z"
        fill="white"
      />
    </svg>

    <button
      class="p-0"
      @click="menu = !menu"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        stroke-width="1.5"
        stroke="currentColor"
        class="w-6 text-white"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          d="M9.594 3.94c.09-.542.56-.94 1.11-.94h2.593c.55 0 1.02.398 1.11.94l.213 1.281c.063.374.313.686.645.87.074.04.147.083.22.127.325.196.72.257 1.075.124l1.217-.456a1.125 1.125 0 0 1 1.37.49l1.296 2.247a1.125 1.125 0 0 1-.26 1.431l-1.003.827c-.293.241-.438.613-.43.992a7.723 7.723 0 0 1 0 .255c-.008.378.137.75.43.991l1.004.827c.424.35.534.955.26 1.43l-1.298 2.247a1.125 1.125 0 0 1-1.369.491l-1.217-.456c-.355-.133-.75-.072-1.076.124a6.47 6.47 0 0 1-.22.128c-.331.183-.581.495-.644.869l-.213 1.281c-.09.543-.56.94-1.11.94h-2.594c-.55 0-1.019-.398-1.11-.94l-.213-1.281c-.062-.374-.312-.686-.644-.87a6.52 6.52 0 0 1-.22-.127c-.325-.196-.72-.257-1.076-.124l-1.217.456a1.125 1.125 0 0 1-1.369-.49l-1.297-2.247a1.125 1.125 0 0 1 .26-1.431l1.004-.827c.292-.24.437-.613.43-.991a6.932 6.932 0 0 1 0-.255c.007-.38-.138-.751-.43-.992l-1.004-.827a1.125 1.125 0 0 1-.26-1.43l1.297-2.247a1.125 1.125 0 0 1 1.37-.491l1.216.456c.356.133.751.072 1.076-.124.072-.044.146-.086.22-.128.332-.183.582-.495.644-.869l.214-1.28Z"
        />
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          d="M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"
        />
      </svg>
    </button>

    <button
      class="p-0"
      @click="fullScreen"
    >
      <svg
        v-if="!adapter.fullScreen"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        fill="currentColor"
        class="w-6 text-white"
      >
        <path
          fill-rule="evenodd"
          d="M15 3.75a.75.75 0 0 1 .75-.75h4.5a.75.75 0 0 1 .75.75v4.5a.75.75 0 0 1-1.5 0V5.56l-3.97 3.97a.75.75 0 1 1-1.06-1.06l3.97-3.97h-2.69a.75.75 0 0 1-.75-.75Zm-12 0A.75.75 0 0 1 3.75 3h4.5a.75.75 0 0 1 0 1.5H5.56l3.97 3.97a.75.75 0 0 1-1.06 1.06L4.5 5.56v2.69a.75.75 0 0 1-1.5 0v-4.5Zm11.47 11.78a.75.75 0 1 1 1.06-1.06l3.97 3.97v-2.69a.75.75 0 0 1 1.5 0v4.5a.75.75 0 0 1-.75.75h-4.5a.75.75 0 0 1 0-1.5h2.69l-3.97-3.97Zm-4.94-1.06a.75.75 0 0 1 0 1.06L5.56 19.5h2.69a.75.75 0 0 1 0 1.5h-4.5a.75.75 0 0 1-.75-.75v-4.5a.75.75 0 0 1 1.5 0v2.69l3.97-3.97a.75.75 0 0 1 1.06 0Z"
          clip-rule="evenodd"
        />
      </svg>
      <svg
        v-else
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        fill="currentColor"
        class="w-6 text-white"
      >
        <path
          fill-rule="evenodd"
          d="M3.22 3.22a.75.75 0 0 1 1.06 0l3.97 3.97V4.5a.75.75 0 0 1 1.5 0V9a.75.75 0 0 1-.75.75H4.5a.75.75 0 0 1 0-1.5h2.69L3.22 4.28a.75.75 0 0 1 0-1.06Zm17.56 0a.75.75 0 0 1 0 1.06l-3.97 3.97h2.69a.75.75 0 0 1 0 1.5H15a.75.75 0 0 1-.75-.75V4.5a.75.75 0 0 1 1.5 0v2.69l3.97-3.97a.75.75 0 0 1 1.06 0ZM3.75 15a.75.75 0 0 1 .75-.75H9a.75.75 0 0 1 .75.75v4.5a.75.75 0 0 1-1.5 0v-2.69l-3.97 3.97a.75.75 0 0 1-1.06-1.06l3.97-3.97H4.5a.75.75 0 0 1-.75-.75Zm10.5 0a.75.75 0 0 1 .75-.75h4.5a.75.75 0 0 1 0 1.5h-2.69l3.97 3.97a.75.75 0 1 1-1.06 1.06l-3.97-3.97v2.69a.75.75 0 0 1-1.5 0V15Z"
          clip-rule="evenodd"
        />
      </svg>
    </button>

    <transition-group>
      <div
        v-if="menu"
        class="config-menu overflow-hidden p-3 absolute w-[300px] min:h-[250px] rounded-lg bg-[#2a2a30] z-[10] right-[20px] bottom-[40px]"
      >
        <div
          v-if="view === 'main'"
          class="flex flex-col"
        >
          <button
            class="w-full text-left py-2 lg:py-3 px-2 rounded-lg !flex items-center gap-1 !transition-all !text-[15px] hover:!bg-white/10 text-white p-0"
            @click="view = 'quality'"
          >
            Quality

            <span class="ml-auto mr-3">{{ adapter.quality.height }}p{{ adapter.quality.frameRate > 30 ? '60' : '' }}</span>

            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke-width="1.5"
              stroke="currentColor"
              class="w-4"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="m8.25 4.5 7.5 7.5-7.5 7.5"
              />
            </svg>
          </button>
          <button
            class="w-full text-left py-2 lg:py-3 px-2 rounded-lg !flex items-center gap-1 !transition-all !text-[15px] hover:!bg-white/10 text-white p-0"
            @click="view = 'metrics'"
          >
            Metrics

            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke-width="1.5"
              stroke="currentColor"
              class="ml-auto w-4"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="m8.25 4.5 7.5 7.5-7.5 7.5"
              />
            </svg>
          </button>
        </div>

        <div v-if="view === 'quality'">
          <button
            class="w-full text-left py-2 lg:py-3 px-2 rounded-lg !flex items-center gap-1 !transition-all !text-[15px] hover:!bg-white/10 text-white p-0"
            @click="view = 'main'"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke-width="1.5"
              stroke="currentColor"
              class="w-4"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M15.75 19.5 8.25 12l7.5-7.5"
              />
            </svg>

            Back
          </button>

          <button
            class="w-full text-left py-2 lg:py-3 px-2 rounded-lg !flex items-center gap-1 !transition-all !text-[15px] hover:!bg-white/10 text-white p-0"
            @click="() => _selectQuality('auto')"
          >
            <svg
              v-if="adapter.isAuto"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke-width="1.5"
              stroke="currentColor"
              class="w-4 mr-1"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M9 12.75 11.25 15 15 9.75M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
              />
            </svg>
            <div
              v-else
              class="rounded-full border border-white w-[13px] h-[13px] mr-2"
            />
            Auto
          </button>

          <button
            v-for="q in adapter.levels"
            :key="q.height"
            class="w-full text-left py-2 lg:py-3 px-2 rounded-lg !flex items-center gap-1 !transition-all !text-[15px] hover:!bg-white/10 text-white p-0"
            @click="() => _selectQuality(q.height)"
          >
            <svg
              v-if="adapter.quality.height === q.height"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke-width="1.5"
              stroke="currentColor"
              class="w-4 mr-1"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M9 12.75 11.25 15 15 9.75M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
              />
            </svg>
            <div
              v-else
              class="rounded-full border border-white w-[13px] h-[13px] mr-2"
            />

            {{ q.height }}p{{ q.frameRate > 30 ? '60' : '' }}
          </button>
        </div>

        <div v-if="view === 'metrics'">
          <button
            class="w-full text-left py-2 lg:py-3 px-2 rounded-lg !flex items-center gap-1 mb-2 !transition-all !text-[15px] hover:!bg-white/10 text-white p-0"
            @click="view = 'main'"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke-width="1.5"
              stroke="currentColor"
              class="w-4"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M15.75 19.5 8.25 12l7.5-7.5"
              />
            </svg>


            Back
          </button>

          <div class="flex flex-col gap-y-1 px-2 text-white">
            <div>Latency: {{ Math.round(adapter.latency * 100) / 100 }}</div>
            <!--            <div>Dropped Frames: {{metrics.droppedVideoFrames}}</div>-->
            <!--            <div>Bandwidth: {{Math.round(metrics.currentBandwidthEstimate * 8 / 1_000_000)}}Mbps</div>-->
          </div>
        </div>
      </div>
    </transition-group>
  </div>
</template>

<script>
export default {
  name: 'ConfimMenu2',
  props: {
    setQuality: Function,
    play: Function,
    pause: Function,
    seek: Function,
    muteUnmute: Function,
    updateVolume: Function,
    selectQuality: Function,
    fullScreen: Function,
    adapter: Object
  },
  data () {
    return {
      volumePanel: false,
      menu: false,
      view: 'main',
      volume: 0
    }
  },
  methods: {
    _selectQuality (index) {
      this.selectQuality(index)
      this.menu = false
    }
  }
}
</script>
